export default `
mutation UpdateProperty($input: UpdatePropertyInput!) {
  updateProperty(input: $input) {
    variant
    patrolWindows {
      minsToStart
      minsToEnd
      darsRequired
    }
    geofence
    place {
      coordinates {
        lat
        lng
      }
      formattedAddress
      addressComponents {
        city
        state
        county
        country
        zipCode
        subpremise
        streetName
        neighborhood
        streetNumber
        zipCodeSuffix
      }
      timezone
    }
    isDeleted
    adminNote
    createdAt
    updatedAt
    propertyId
    instanceId
    instancedAt
    displayName
    cardinal {
      time {
        start
        end
      }
      indefiniteStart
      note
      indefinite
    }
    serviceProviderId
    serviceProviderNote
  }
}
`;